export const DASHBOARD_SECTIONS = [
  { id: 'overzicht', hash: 'overzicht', label: 'Overzicht' },
  { id: 'mail', hash: 'mail', label: 'Mail' },
  { id: 'google', hash: 'google', label: 'Google' },
  { id: 'leads', hash: 'leads', label: 'Leads' },
] as const;

/** Wireframe 4.1 — alleen operatie-blokken in sticky nav */
export const DASHBOARD_SECTIONS_41 = DASHBOARD_SECTIONS.filter(
  (s) => s.id === 'overzicht' || s.id === 'mail',
);

/** Wireframe 4.2 — + Google in sticky nav */
export const DASHBOARD_SECTIONS_42 = DASHBOARD_SECTIONS.filter(
  (s) => s.id !== 'leads',
);

export type DashboardSectionId = (typeof DASHBOARD_SECTIONS)[number]['id'];
